export const extractSubItemsFromTeam = (team) => {
  const currentSub = team?.stripeCustomer?.subscriptions?.data?.find(
    ({ id }) => id === team.team.stripeSubscription.split("%")[1],
  );

  const seatsItem = currentSub?.items?.data?.find(
    ({ id }) => id === team.team?.stripeSubscription?.split("%")[0],
  );

  const freeSeatsItem = currentSub?.items?.data?.find(
    ({ id }) => id === team.team?.freeSeatsStripeSubscription?.split("%")[0],
  );

  const leadsItem = currentSub?.items?.data?.find(
    ({ id }) => id === team.team?.leadCaptureStripeSubscription?.split("%")[0],
  );

  return {
    freeSeatsItem,
    seatsItem,
    leadsItem,
  };
};
